import ReactDOM from 'react-dom'
import App from './app'
import './styles/index.css'

ReactDOM.render(<App/>, document.querySelector("#root"));